import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/Card";
import { Button } from "../ui/Button";
import { CheckCircledIcon, ArrowRightIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";

export const PasswordResetSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <Card className="w-full max-w-md bg-white shadow-none border border-border-gray rounded-none">
      <CardHeader className="text-center space-y-4 pt-12 pb-8">
        <CardTitle className="text-xl font-bold uppercase tracking-wide">
          PASSWORD
          <br />
          SUCCESSFULLY RESET
        </CardTitle>
        <CardDescription className="text-sm text-gray-600">
          Your password has been changed
          <br />
          successfully. You can now Log In to
          <br />
          your account with your new password
        </CardDescription>
      </CardHeader>
      <CardContent className="px-8 pb-12">
        <Button
          onClick={handleGoToLogin}
          className="w-full h-12 bg-primary-blue hover:bg-primary-blue/90 text-white font-normal rounded-none"
        >
          Go to Login
        </Button>
      </CardContent>
    </Card>
  );
};
